import BillingDashboard from '@/models/general/settings/BillingDashboard';
import current from './current';
import paymentHistory from './paymentHistory';
import paymentMethods from './paymentMethods';
import emailNotifications from './emailNotifications';

export default {
  namespaced: true,

  modules: {
    current,
    paymentMethods,
    paymentHistory,
    emailNotifications,
  },

  actions: {
    async fetchBillingDashboardData({ dispatch, rootState }) {
      dispatch('general/settings/billingDashboard/paymentMethods/getPaymentMethods', null, {
        root: true,
      });
      dispatch('general/settings/billingDashboard/current/getCurrent', null, { root: true });

      let billings = rootState.general.settings.billingDashboard.paymentHistory.billings;
      let page = rootState.general.settings.billingDashboard.paymentHistory.pagination.page;

      if (!billings || !billings.length || page) {
        dispatch(
          'general/settings/billingDashboard/paymentHistory/getPaymentHistory',
          `?page=${page}`,
          { root: true }
        );
      }

      dispatch('general/settings/billingDashboard/emailNotifications/getEmails', null, {
        root: true,
      });
    },

    async calculateBilling({ dispatch }, id) {
      try {
        const { data } = await BillingDashboard.calculateBilling(id);
        if (!data.error) {
          dispatch('fetchBillingDashboardData');
        }
        return data;
      } catch (error) {
        console.error(error);
        return error.response.data;
      }
    },
  },
};
